import { create } from "zustand";
import { devtools } from "zustand/middleware";
export const useIfdoStore = create()(devtools((set)=>({
        initialized: false,
        setInitialized: (initialized)=>set(()=>({
                    initialized
                }))
    })));
